import type { Board } from "../../board";
import { Timing } from "../../effects/effect";
import { PRIORITY_DEFAULT } from "../../interfaces";
import type { OnAddToBoard, ProcessableThing } from "../../interfaces";
import { Thing } from "../../thing";
import type { XY } from "../../xy";
import type { SoundId } from "./soundId";

export class Sound extends Thing implements ProcessableThing, OnAddToBoard {
	static key = "Sound";
	xy: XY | null;
	loop: boolean = false;
	soundId: SoundId;
	turnAddedToBoard: number = 0;
	randomPitchVariation: number = 0.2;
	volume: number;
	/** Scales the global distance falloff; <1 carries farther, 0 ignores distance. */
	attenuationFactor: number = 1;
	/** Floor the distance falloff can't drop below, so the sound stays audible anywhere. */
	minVolume: number = 0;
	private timing: Timing | null = null;
	private animationOrder: number = 0;

	constructor(soundId: SoundId, xy?: XY, volume?: number) {
		super();
		this.soundId = soundId;
		this.xy = xy ?? null;
		this.volume = volume ?? 0.7;
	}

	getTiming(): Timing | null {
		return this.timing;
	}

	setTiming(timing: Timing | null): void {
		this.timing = timing;
	}

	getAnimationOrder(): number {
		return this.animationOrder;
	}

	setAnimationOrder(order: number): void {
		this.animationOrder = order;
	}

	hasSource(): boolean {
		return this.xy !== null;
	}

	processTurn(_board: Board): void {
		if (!this.loop) {
			this.board!.removeAtEndOfTurn(this);
		}
	}

	getProcessPriority(): number {
		return PRIORITY_DEFAULT;
	}

	onAddToBoard(): void {
		this.turnAddedToBoard = this.board!.turnCount;
	}

	shouldSerialize(): boolean {
		return false;
	}
}
